import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { colors } from '@guryou/colors';
import { FlexColumn, FlexRow, LargeText, SmallText, Spinner } from '@guryou/html-components';
import { PROVIDER_GET_GENERAL_INFO, PROVIDER_LATEST_WIDGET, randomProvidersActionByKeywordOrAddress, resetState, stateIsLoaded } from '@guryou/redux';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import CardCarousel from './carousel';
import CarouselSlide from './CarouselSlide';
import Filters from './Filters';

const defaultState = {
  type: 'C',
  keyword: null,
  address: null,
};

const Centers = ({ width }) => {
  const { t } = useTranslation();
  const [values, setValues] = useState(defaultState);

  const dispatch = useDispatch();

  const history = useHistory();
  const { i18n } = useTranslation();

  const randomProviders = useSelector(state => state.randomProviders);

  const data = [...(randomProviders?.data?.response?.centers || []), ...(randomProviders?.data?.response?.professionals || [])];

  useEffect(() => {
    dispatch(randomProvidersActionByKeywordOrAddress());
  }, [dispatch]);

  const handleSwitchChange = value => setValues(pv => ({ ...pv, type: value }));
  const handleKeywordChange = e => {
    e.persist();
    setValues(pv => ({ ...pv, keyword: e.target?.value }));
  };
  const handleAddressChange = address => setValues(pv => ({ ...pv, address }));

  const onSubmit = () => {
    const { type, keyword, address } = values;
    let city = null;
    let country = null;
    if (address?.address_components) {
      const localityCity = address?.address_components.find(x => x.types.includes('locality'));
      const localityCountry = address?.address_components.find(x => x.types.includes('country'));
      if (localityCity) {
        city = localityCity?.long_name;
      }
      if (localityCountry) {
        country = localityCountry.long_name;
      }
    }
    dispatch(randomProvidersActionByKeywordOrAddress(keyword, city, country, type));
  };

  const handleProviderClick = (e, id) => {
    e.preventDefault();
    dispatch(resetState(PROVIDER_GET_GENERAL_INFO));
    dispatch(resetState(PROVIDER_LATEST_WIDGET));
    return history.push(`/${i18n.language}/provider/${id}`);
  };

  return (
    <section class="bg-white py-32">
      <div class="py-8 px-4 mx-auto max-w-screen-xl lg:py-32 lg:px-6">
        <div class="mx-auto max-w-screen-sm text-center mb-8 lg:mb-16">
          <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900">{t('YF_SEARCH.whatAreYouLookingFor')}</h2>
          <p class="font-light text-gray-500 lg:mb-16 sm:text-xl">
            Prenota: utilizza il nostro servizio di ricerca per esplorare, scegliere e prenotare le migliori esperienze wellness, su misura per te.
          </p>
        </div>
        <Filters
          width={width}
          onChange={handleSwitchChange}
          switchValue={values.type}
          handleKeywordChange={handleKeywordChange}
          handleAddressChange={handleAddressChange}
          onSubmit={onSubmit}
        />
        {!stateIsLoaded(randomProviders) ? (
          <div class="flex items-center justify-center w-full mt-8">
            <Spinner />
          </div>
        ) : (
          <div class="grid gap-8 mb-6 py-16 lg:mb-16 sm:grid-cols-2 md:grid-cols-3">
            {data.map(card => (
              <div class="max-w-sm flex flex-col  bg-gray-50 rounded-lg shadow" key={card.id}>
                <a href="#" onClick={e => handleProviderClick(e, card.id)}>
                  <img class="w-full h-64 rounded-lg sm:rounded-none sm:rounded-l-lg  object-cover" src={card.images[0].medium} alt={card.name} />
                </a>

                <div class="p-5 w-full flex flex-col">
                  <h3 class="text-xl font-bold tracking-tight text-gray-900">
                    <a href="#">{card.name}</a>
                  </h3>
                  <span class="text-gray-500 line-clamp-1">{card.address}</span>
                  <p class="mt-3 mb-4 font-light text-gray-500 line-clamp-4 break-all">{card.description}</p>
                  <span class="text-gray-500 line-clamp-1">{card?.categories.map(cat => cat.name).join(', ')}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* <div class="py-8 px-4 mx-auto max-w-screen-xl lg:px-6">
          <div class="grid gap-8 lg:gap-16 sm:grid-cols-2 md:grid-cols-3">
            {!stateIsLoaded(randomProviders) ? (
              <Spinner />
            ) : (
              data.map(card => (
                <div class="items-center bg-gray-50 rounded-lg shadow" key={card.id}>
                  <a href="#">
                    <img class="w-full h-64 rounded-lg sm:rounded-none sm:rounded-l-lg  object-cover" src={card.images[0].medium} alt={card.name} />
                  </a>

                  <div class="p-5">
                    <h3 class="text-xl font-bold tracking-tight text-gray-900">
                      <a href="#">{card.name}</a>
                    </h3>
                    <span class="text-gray-500 line-clamp-1">{card?.categories.map(cat => cat.name).join(', ')}</span>
                    <p class="mt-3 mb-4 font-light text-gray-500 line-clamp-4">{card.description}</p>
                  </div>
                </div>
              ))
            )}
          </div>
        </div> */}
      {/* <FlexRow xs={11} justifyContent={width < 650 ? 'center' : 'space-between'} marginBottom={10} marginTop={width > 650 && 15} alignItems="center">
        <LargeText fontSize="2.7rem" fontWeight={900}>
          {t('YF_SEARCH.recommendedForYou')}
        </LargeText>
        {width < 650 ? (
          ''
        ) : (
          <SmallText fontSize={width < 1400 ? '1rem' : '1.5rem'}>
            {t('YF_SEARCH.lookingForCenter')} <ArrowForwardIcon style={{ verticalAlign: 'middle' }} />
          </SmallText>
        )}
      </FlexRow>
      {!stateIsLoaded(randomProviders) ? (
        <Spinner />
      ) : (
        <CardCarousel
          CarouselSlide={
            <CarouselSlide width={width} data={randomProviders.data?.response} type={values.type} noResult={t('GENERAL.noProvidersFound')} />
          }
          width={width}
          totalSlides={values.type === null ? 10 : 1000}
        />
      )} */}
    </section>
  );
  // return (
  //   <FlexColumn marginTop={width < 900 && 15} marginBottom={10}>
  //     <Filters
  //       width={width}
  //       onChange={handleSwitchChange}
  //       switchValue={values.type}
  //       handleKeywordChange={handleKeywordChange}
  //       handleAddressChange={handleAddressChange}
  //       onSubmit={onSubmit}
  //     />
  //     <FlexRow xs={11} justifyContent={width < 650 ? 'center' : 'space-between'} marginBottom={10} marginTop={width > 650 && 15} alignItems="center">
  //       <LargeText fontSize="2.7rem" fontWeight={900}>
  //         {t('YF_SEARCH.recommendedForYou')}
  //       </LargeText>
  //       {width < 650 ? (
  //         ''
  //       ) : (
  //         <SmallText fontSize={width < 1400 ? '1rem' : '1.5rem'}>
  //           {t('YF_SEARCH.lookingForCenter')} <ArrowForwardIcon style={{ verticalAlign: 'middle' }} />
  //         </SmallText>
  //       )}
  //     </FlexRow>
  //     {!stateIsLoaded(randomProviders) ? (
  //       <Spinner />
  //     ) : (
  //       <CardCarousel
  //         CarouselSlide={
  //           <CarouselSlide width={width} data={randomProviders.data?.response} type={values.type} noResult={t('GENERAL.noProvidersFound')} />
  //         }
  //         width={width}
  //         totalSlides={values.type === null ? 10 : 1000}
  //       />
  //     )}
  //   </FlexColumn>
  // );
};

export default Centers;
